import { Component, inject, OnInit } from '@angular/core';
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { PasswordModule } from 'primeng/password';
import { FormsModule, ReactiveFormsModule, FormGroup, FormControl } from '@angular/forms';
import { AuthService } from '../../data-services/auth.service';
import { Message, MessageModule } from 'primeng/message';
import { FacebookLoginProvider, GoogleLoginProvider, GoogleSigninButtonModule, MicrosoftLoginProvider, SocialAuthService, SocialLoginModule, SocialUser } from '@abacritt/angularx-social-login';
import { RouterModule } from '@angular/router';
import { FaIconComponent, FaIconLibrary, FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { faFacebook, faMicrosoft, faGoogle } from '@fortawesome/free-brands-svg-icons';
import { faUser, faLock} from '@fortawesome/free-solid-svg-icons';
import { MessageService } from 'primeng/api';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-auth-login',
    imports: [InputTextModule, InputGroupModule, InputGroupAddonModule, PasswordModule, FormsModule, ReactiveFormsModule, MessageModule, SocialLoginModule, GoogleSigninButtonModule, RouterModule, FontAwesomeModule, Message],
    templateUrl: '../ui/login.component.html',
    styleUrl: '../ui/login.component.css',
})
export class LoginComponent implements OnInit {
  //private readonly _socialAuthService = inject(SocialAuthService);
  private readonly _iconLib = inject(FaIconLibrary);
  private readonly _authService = inject(AuthService);
  private readonly _titleService = inject(Title)
  loginProfile = new FormGroup({
    email: new FormControl(),
    password: new FormControl()
  })
  user: SocialUser | undefined;
  GoogleLoginProvider = GoogleLoginProvider;

  ngOnInit(): void {
    this._titleService.setTitle('LRPTickets.co.uk | Login')
    this._iconLib.addIcons(faFacebook,faMicrosoft,faGoogle,faUser,faLock)
    // this._socialAuthService.authState.subscribe((user) => {
    //   this.user = user;
    //   console.log(user)
    //   this._authService.socialLogin({
    //     email: user.email ?? '',
    //     firstname: user.firstName,
    //     surname: user.lastName,
    //     facebookId: user.provider === FacebookLoginProvider.PROVIDER_ID ? user.id : undefined,
    //     googleId: user.provider === GoogleLoginProvider.PROVIDER_ID ? user.id : undefined,
    //     microsoftId: user.provider === MicrosoftLoginProvider.PROVIDER_ID ? user.id : undefined,
    //     authToken: user.authToken
    //   })
    // })
  }

  performLogin() {
    this._authService.login({
      email: this.loginProfile.value.email,
      password: this.loginProfile.value.password
    })
  }

  signInWithFB(): void {
    //this._socialAuthService.signIn(FacebookLoginProvider.PROVIDER_ID);
  }

  signInWithMicrosoft(): void {
    //this._socialAuthService.signIn(MicrosoftLoginProvider.PROVIDER_ID);
  }

  refreshGoogleToken(): void {
    //this._socialAuthService.refreshAuthToken(GoogleLoginProvider.PROVIDER_ID);
  }
}
